"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reclaim = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var reclaim = function reclaim(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'reclaim-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M5 4C5.41421 4 5.75 4.33579 5.75 4.75V11.75C5.75 12.8496 6.07694 13.6413 6.59283 14.1572C7.10872 14.6731 7.90038 15 9 15H11C11.9507 15 12.7573 14.6829 13.321 14.1449C13.8793 13.6122 14.25 12.815 14.25 11.75C14.25 10.6718 13.8953 9.87356 13.3615 9.34585C12.8251 8.81558 12.0488 8.5 11.1 8.5H8.5C8.08579 8.5 7.75 8.16421 7.75 7.75C7.75 7.33579 8.08579 7 8.5 7H11.1C12.3879 7 13.5616 7.43442 14.4161 8.27915C15.2731 9.12644 15.75 10.3282 15.75 11.75C15.75 13.185 15.2391 14.3878 14.3566 15.2301C13.4795 16.0671 12.2861 16.5 11 16.5H9C7.59962 16.5 6.39128 16.0769 5.53217 15.2178C4.67306 14.3587 4.25 13.1504 4.25 11.75V4.75C4.25 4.33579 4.58579 4 5 4Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M10.0478 4.88429L7.32673 7.10598C6.89109 7.46166 6.89109 8.03834 7.32673 8.39402L10.0478 10.6157C10.3992 10.9026 11 10.6994 11 10.2937V5.2063C11 4.80059 10.3992 4.59741 10.0478 4.88429Z',
    fill: '#4B5563'
  }));
};

exports.reclaim = reclaim;